import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdLanguage } from "react-icons/md";

const FRAME_COLOR = "#F6615F";
const VIDEO_VIEWPORT_STYLE = {
  aspectRatio: "21 / 9",
  overflow: "hidden",
  position: "relative",
};
const VIDEO_IFRAME_STYLE = {
  border: 0,
  display: "block",
  height: "100%",
  inset: 0,
  position: "absolute",
  width: "100%",
};

const VIDEOS = {
  dk: [
    {
      id: "dk-paramediciner",
      title: "Paramediciner : Martin Assentoft",
      src: "https://player.vimeo.com/video/815813767?h=b395673b1b&badge=0&autopause=0&player_id=0&app_id=58479",
      description:
        "Formål med video: fortælle om problemer, der kan opstå for lægpersoner, når en ulykke er sket og hvordan Action-cards kan hjælpe med at afhjælpe disse problemer. Vises i starten af et kursus og i markedsføring.",
      course: "Instruktør video",
    },
    {
      id: "dk-instruktor",
      title: "Action-cards® instruktør - Asger Helmig",
      src: "https://player.vimeo.com/video/807825478?h=b0d6749ae6&badge=0&autopause=0&player_id=0&app_id=58479",
      description:
        "Formål med video: A til Z video, der fortæller hvordan førstehjælpstræning med Action-cards forløber. Vises i starten af et kursus.",
      course: "Instruktør video",
    },
    {
      id: "dk-forsvaret",
      title: "Uddannelsesansvarlig i forsvaret - Søren Marcussen",
      src: "https://player.vimeo.com/video/811959237?h=29512bca55&badge=0&autopause=0&player_id=0&app_id=58479",
      description:
        "Formål med video: Give indblik i 5 krisestyringsproblemer for mindre grupper og hvordan man kan håndtere disse problemer. Vises undervejs i et kursus.",
      course: "Instruktør video",
    },
  ],
  en: [
    {
      id: "en-paramedic",
      title: "Paramedic: Martin Assentoft",
      src: "https://player.vimeo.com/video/820437024?badge=0&autopause=0&player_id=0&app_id=58479",
      description:
        "Purpose of video: tell about problems that can arise for lay people when an accident has occurred and how Action-cards can help to remedy these problems. Appears at the start of a course and in marketing.",
      course: "Instruction video",
    },
    {
      id: "en-instructor",
      title: "Action-cards® instructor - Asger Helmig",
      src: "https://player.vimeo.com/video/820853123?h=a671830a53&badge=0&autopause=0&player_id=0&app_id=58479",
      description:
        "Purpose of video: A to Z video that explains how first aid drills with Action cards proceeds. Appears at the start of a course.",
      course: "Instruction video",
    },
    {
      id: "en-army",
      title: "Armed Forces Educational responsible - Søren Marcussen",
      src: "https://player.vimeo.com/video/820853359?h=67b3c9b036&badge=0&autopause=0&player_id=0&app_id=58479",
      description:
        "Purpose of video: Give insight into 5 crisis management problems for smaller groups and how to deal with problems. Appears during a course.",
      course: "Instruction video",
    },
  ],
};

const InstructionVideo = () => {
  const [t] = useTranslation();
  const [activeLang, setActiveLang] = useState("dk");

  const videos = VIDEOS[activeLang];
  const renderVideoCard = (video) => (
    <article
      key={video.id}
      className="mb-7 overflow-hidden rounded-xl p-4 shadow-[0_18px_42px_rgba(31,41,55,0.18)] ring-1 ring-black/10 sm:p-5"
      style={{ backgroundColor: FRAME_COLOR }}
    >
      <div
        className="rounded-lg bg-black shadow-inner"
        style={VIDEO_VIEWPORT_STYLE}
      >
        <iframe
          src={video.src}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          className="block"
          style={VIDEO_IFRAME_STYLE}
          title={video.title}
        />
      </div>

      <div
        className="mt-4 flex flex-col gap-2"
        style={{ backgroundColor: FRAME_COLOR }}
      >
        <h2 className="m-0 text-lg font-bold leading-snug text-white">
          {video.title}
        </h2>
        <p className="m-0 text-sm leading-6 text-white">
          {video.description}
        </p>
      </div>
    </article>
  );

  return (
    <div className="min-h-[93vh] overflow-auto bg-white p-3 text-[#20232A] sm:p-4">
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h1 className="m-0 text-[24px] font-bold leading-tight text-black md:text-[30px]">
          {t("userMenuSidebar.label.InstructionVideos")}
        </h1>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setActiveLang("dk")}
            className={`rounded-md border px-4 py-1.5 text-sm font-semibold transition-colors ${
              activeLang === "dk"
                ? "border-transparent bg-[#F6615F] text-white"
                : "border-gray-200 bg-white text-gray-600 hover:bg-gray-50"
            }`}
          >
            {t("IntroductionVideo.label.Danish") || "Danish"}
          </button>
          <button
            type="button"
            onClick={() => setActiveLang("en")}
            className={`flex items-center gap-1 rounded-md border px-4 py-1.5 text-sm font-semibold transition-colors ${
              activeLang === "en"
                ? "border-transparent bg-[#F6615F] text-white"
                : "border-gray-200 bg-white text-gray-600 hover:bg-gray-50"
            }`}
          >
            <MdLanguage size={16} />
            {t("IntroductionVideo.label.English") || "English"}
          </button>
        </div>
      </div>
      <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_280px]">
        <div>{videos.map((video) => renderVideoCard(video))}</div>
      </div>
    </div>
  );
};

export default InstructionVideo;
